import {Outlet} from 'react-router-dom'
import {StyledPrivateLayout} from './style.ts'
import {Navbar} from '@components/commons/navbar/Navbar.tsx'

export const PrivateLayout = () => {
    return (
        <StyledPrivateLayout>
            <Navbar />
            <Outlet />
        </StyledPrivateLayout>
    )
}
